<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="760px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :validate-on-rule-change="false"
      :model="ruleForm"
      :rules="rules"
      label-width="100px">
      <el-form-item
        label="内容标题："
        prop="title">
        <el-input
          v-model="ruleForm.title"
          show-word-limit
          :maxlength="20"></el-input>
      </el-form-item>
      <el-form-item label="内容说明：">
        <el-input
          v-model="ruleForm.name"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 4}"
          show-word-limit
          :maxlength="150"></el-input>
      </el-form-item>
      <el-form-item
        label="内容详情："
        prop="content">
        <desc-images
          v-model="ruleForm.content"
          :edit="true"></desc-images>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import DescImages from '@/components/public/desc-images.vue'
import Portal from '@/service/portal'
export default {
  name: 'EditMessageModal',
  components: { DescImages },
  data() {
    return {
      loading: false,
      visible: false,
      ruleForm: { msgId: null, title: '', name: '', contentType: 0, content: [] },
      rules: {
        title: [
          { required: true, message: '请输入内容标题', trigger: 'blur' }
        ],
        name: [
          { min: 3, max: 30, message: '请输入内容说明', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请上传图文详情', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    title({ ruleForm }) {
      return (ruleForm.id ? '编辑' : '新增') + '内容'
    }
  },
  methods: {
    handleClosed() {
      this.ruleForm = { ...this.ruleForm, ...this.$options.data().ruleForm }
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const { msgId, content } = this.ruleForm
          const dispatch = msgId ? 'updatemessage' : 'addmessage'
          Portal[dispatch]({
            ...this.ruleForm,
            content: this.$stringfyImage(content),
            isShowImage: 1,
            status: 2
          })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('提交成功')
                this.visible = false
                this.$emit('fetch')
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        }
      })
    },
    init(options = {}) {
      this.ruleForm = { ...this.ruleForm, ...options }
      this.visible = true
    }
  }
}
</script>
